import { FC, useEffect, useState } from 'react'

import {
  TableBodyStyled,
  TableCellStyled,
  TableContainerStyled,
  TableHeadStyled,
  TableRowStyled,
  TableStyled,
  TableFooter,
  Span,
  Copy
} from 'components'
import { MagnifyingGlassIcon } from 'components/Icons'
import { useTabs } from 'hooks'
import moment from 'moment'
import { FORMAT, COLORS } from 'utils'

export interface tableDataInterface {
  contratoCobradoId: number
  contratoPendenteId: number
  cdContrato: string
  fornecedorId: number
  nomeFornecedor: number
  idBloqueio: number
  idMotivo: number
  motivo: string
  dataBloqueio: Date
  dataLiberacao: Date
  txReferencia: string
  txDocumento: string
  cdFolhaRegistroSRV: string
  vlLiquido: number
}

interface ITableSearchRecordsSheet {
  tableData: tableDataInterface[]
  setPage: any
  totalItems: number
  pageSize: number
  setPageSize: any
  page: number
  setDataTable: any
  handleVerContrato: (_id: number) => void
}

const TableSearchRecordsSheet: FC<ITableSearchRecordsSheet> = ({
  tableData,
  setPage,
  totalItems,
  pageSize,
  setPageSize,
  page,
  handleVerContrato,
  setDataTable
}) => {
  const { handleAddTab, tabs, handleRemoveTab, rawTabs } = useTabs()

  const handleChangePage = (newPage: number) => setPage(newPage)

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setPageSize(parseInt(event.target.value, 10))
    setPage(1)
  }

  const changePage = (row: tableDataInterface) => {
    setDataTable(row)

    if (tabs.length > 3) {
      handleRemoveTab({
        removeAndNavigateToPreviousDefaultTab: true,
        tabName: rawTabs[3]?.name,
        position: 3
      })

      handleAddTab({
        createAndNavigateToNewTab: true,
        tabName: row.cdContrato
      })
    } else {
      handleAddTab({
        tabName: row.cdContrato,
        createAndNavigateToNewTab: true
      })
    }
  }
  const [rederingTableData, setRederingTableData] =
    useState<tableDataInterface[]>()

  useEffect(() => {
    setRederingTableData(tableData)
  }, [tableData])

  let vlLiquidoTotal = 0;

  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled></TableCellStyled>
              <TableCellStyled align="left" style={{ paddingRight: '-3rem' }}>Nº Contrato</TableCellStyled>
              <TableCellStyled align="left">Fornecedor</TableCellStyled>
              <TableCellStyled align="center">Motivo</TableCellStyled>
              <TableCellStyled align="center">Data Bloqueio</TableCellStyled>
              <TableCellStyled align="center">Data Liberação</TableCellStyled>
              <TableCellStyled align="center">Referência</TableCellStyled>
              <TableCellStyled align="center">Documento</TableCellStyled>
              <TableCellStyled align="center">Folha de Registro</TableCellStyled>
              <TableCellStyled align="center">Valor Líquido</TableCellStyled>
              <TableCellStyled align="center">Ação</TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {rederingTableData?.map((row) => (
              <TableRowStyled key={row?.contratoCobradoId}>
                <TableCellStyled align="left">
                  <Copy
                    title="Copiar código de contrato"
                    valueToCopy={row.cdContrato}
                  />
                </TableCellStyled>
                <TableCellStyled
                  align="left"
                  onClick={() => handleVerContrato(row.contratoPendenteId)}
                >
                  <Span text={row?.cdContrato} color={COLORS.blueFonts} style={{ paddingRight: '1rem' }} />
                </TableCellStyled>
                <TableCellStyled align="left">
                  {row?.nomeFornecedor}
                </TableCellStyled>
                <TableCellStyled align="center">{row?.motivo}</TableCellStyled>
                <TableCellStyled align="center">
                  {moment(row?.dataBloqueio).format('DD/MM/YYYY') ==
                    '01/01/0001'
                    ? '----'
                    : moment(row?.dataBloqueio).format('DD/MM/YYYY')}
                </TableCellStyled>
                <TableCellStyled align="center">
                  {moment(row?.dataLiberacao).format('DD/MM/YYYY') ==
                    '01/01/0001'
                    ? '----'
                    : moment(row?.dataLiberacao).format('DD/MM/YYYY')}
                </TableCellStyled>
                <TableCellStyled align="center">
                  {row?.txReferencia}
                </TableCellStyled>
                <TableCellStyled align="center">
                  {row?.txDocumento}
                </TableCellStyled>
                <TableCellStyled align="center">
                  {row?.cdFolhaRegistroSRV}
                </TableCellStyled>
                <TableCellStyled align="center">
                  {row?.vlLiquido ? FORMAT.currency(row.vlLiquido) : 'R$ 0,00'}
                </TableCellStyled>
                <TableCellStyled align="center" onClick={() => {changePage(row);}}>        
              <MagnifyingGlassIcon style={{ justifyContent: 'center' }} hoverText="Liberar/Consultar" />
            </TableCellStyled>
              </TableRowStyled>
            ))}
            {
              rederingTableData?.forEach((row) => {
                vlLiquidoTotal += row?.vlLiquido || 0;
              })
            }
          </TableBodyStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled></TableCellStyled>
              <TableCellStyled></TableCellStyled>
              <TableCellStyled></TableCellStyled>
              <TableCellStyled></TableCellStyled>
              <TableCellStyled></TableCellStyled>
              <TableCellStyled></TableCellStyled>
              <TableCellStyled></TableCellStyled>
              <TableCellStyled></TableCellStyled>
              <TableCellStyled></TableCellStyled>
              <TableCellStyled align="left">
                {vlLiquidoTotal ? FORMAT.currency(vlLiquidoTotal) : 'R$ 0,00'}
              </TableCellStyled>
              <TableCellStyled></TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
        </TableStyled>
      </TableContainerStyled>
      <TableFooter
        page={page}
        rows={tableData}
        totalItems={totalItems}
        rowsPerPage={pageSize}
        handleChangePage={(page) => handleChangePage(page)}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </>
  )
}

export default TableSearchRecordsSheet
